import fetch from "@/plugin/axios"

export function page(query) {
  return fetch({
    url: "/admin/baseUser/page",
    method: "get",
    params: query
  })
}

export function addObj(obj) {
  return fetch({
    url: "/admin/baseUser",
    method: "post",
    data: obj
  })
}

export function getObj(id) {
  return fetch({

    url: "/admin/baseUser/" + id,
    method: "get"
  })
}

export function delObj(id) {
  return fetch({
    url: "/admin/baseUser/" + id,
    method: "delete"
  })
}

export function putObj(id, obj) {
  return fetch({
    url: "/admin/baseUser/" + id,
    method: "put",
    data: obj
  })
}
